/**
 * Brands Navigation
 * Handles A-Z letter navigation and heading positioning for the brands mega menu.
 * Headings are absolutely positioned and aligned via JS to match their
 * letter group's first link in the separate column-flow grid.
 */

class BrandsNavigation {
  constructor(navElement) {
    this.nav = navElement;
    this.scrollerId = this.nav.getAttribute('data-brands-nav');
    this.scroller = document.querySelector(
      `[data-brands-scroller="${this.scrollerId}"]`
    );

    if (!this.scroller) return;

    this.grid = this.scroller.querySelector('.brands-scroller__grid');
    this.buttons = this.nav.querySelectorAll('[data-brand-nav-letter]');

    this.#positionHeadings();
    this.#bindEvents();

    this.resizeObserver = new ResizeObserver(() => this.#positionHeadings());
    this.resizeObserver.observe(this.grid);
  }

  #positionHeadings() {
    const headings = this.scroller.querySelectorAll('.brands-scroller__heading');
    headings.forEach((heading) => {
      const letter = heading.getAttribute('data-brand-letter');
      const firstLink = this.grid.querySelector(
        `[data-brand-group="${letter}"]`
      );
      if (firstLink) {
        heading.style.left = `${firstLink.offsetLeft}px`;
      }
    });
  }

  #bindEvents() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.#handleLetterClick);
    });
  }

  #handleLetterClick = (event) => {
    const letter = event.currentTarget.getAttribute('data-brand-nav-letter');
    const target = this.grid.querySelector(
      `[data-brand-group="${letter}"]`
    );

    if (!target) return;

    this.scroller.scrollTo({
      left: target.offsetLeft,
      behavior: 'smooth',
    });
  };
}

function initBrandsNavigation() {
  const navElements = document.querySelectorAll('[data-brands-nav]');
  navElements.forEach((nav) => new BrandsNavigation(nav));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBrandsNavigation);
} else {
  initBrandsNavigation();
}
